import React from 'react'
import { connect } from 'react-redux'
import DatePicker from 'react-datepicker';
import { getPerfisVendedores } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import SelecaoCidadeAutocomplete from '../layout/SelecaoCidadeAutocomplete';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import selecionarDataIda from '../../actions/origem/selecionarDataIda';
import buscarViagens from '../../actions/viagem/buscarViagens';
import selecionarViagem from '../../actions/viagem/selecionarViagem';
import limparViagens from '../../actions/viagem/limpaViagens';
import selecionarViagemIda from '../../actions/viagem/selecionarViagemIda';
import { campoBuscaTipoVeiculo } from '../../util/constantsUtil';

export const CabecalhoTabela = () => (
  <div id="header-tabela" className="lista-table">
    <div className="row cabecalho-desktop">
      <div className="col-lg-2 col-xl-2">Saida</div>
      <div className="col-lg-2 col-xl-2">Chegada</div>
      <div className="col-lg-4 col-xl-4">Embarque</div>
      <div className="col-lg-2 col-xl-2">Veiculo</div>
      <div className="col-lg-2 col-xl-2">Empresa</div>
    </div>
  </div>
);

export class AbaItinerario extends React.Component {
  exibirBotaoPesquisar () {
    return (
      <Autorizacao perfisPermitidos={[...getPerfisVendedores(this.props.empresaSelecionada.id)]}>
        <div className="col-12 col-sm-9 col-md-2">
          <button onClick={() => this.props.buscarViagens(
            this.props.origem.id,
            this.props.destino.id,
            this.props.dataIda,
            null,
            this.props.empresaSelecionada.id,
            true,
            true,
            campoBuscaTipoVeiculo.TODOS.chave
          )} style={{ fontSize: 18 }}
                  disabled={!this.props.origem || !this.props.destino || !this.props.dataIda}
                  className='btn botaoLogar btn-laranja'>Buscar
          </button>
        </div>
      </Autorizacao>)
  }

  exibirCalendario () {
    return (
      <div>
        <div className="linha">
          <DatePicker
            className='form-control form-control-lg campo-busca'
            value={this.props.dataIda}
            minDate={new Date()}
            selected={this.props.dataIda}
            onChange={(date) => { this.props.selecionarDataIda(date); this.limpaViagens('data') }}
            placeholderText="Data de Saída"
            dateFormat="dd/MM/yyyy"
            locale="pt-BR"
            withPortal
          />
        </div>
      </div>
    )
  }

  exibirItinerario (passagens) {
    if (passagens && passagens.length) {
      return (
        <div className='mt-4'>
          <CabecalhoTabela/>
          <div className="lista-table">
            <div className="geral">
              {passagens.map(viagem => <a target="_BLANK" key={viagem.idItinerario} style={{ cursor: 'pointer' }} onClick={() => this.props.selecionarViagem(viagem)}>
                <div className={`${viagem === this.props.viagem ? 'resumo-laranja' : 'resumo'}`} key={viagem.idItinerario}>
                  <div className='row'>
                    <div className="col-lg-2 col-xl-2">
                      <span className="titulo-mobile">Saída:&nbsp;</span>
                      {viagem.dataPartida} às {viagem.horaPartida}
                    </div>
                    <div className="col-lg-2 col-xl-2">
                      <span className="titulo-mobile">Chegada:&nbsp;</span>
                      {viagem.dataChegada} às {viagem.horaChegada}
                    </div>
                    <div className="col-lg-4 col-xl-4">
                      <span className="titulo-mobile">Embarque:&nbsp;</span>
                      {viagem.embarque}
                    </div>
                    <div className="col-lg-2 col-xl-2">
                      <span className="titulo-mobile">Veículo:&nbsp;</span>{viagem.descricaoTipoVeiculo}
                    </div>
                    <div className="col-lg-2 col-xl-2">
                      {viagem.nomeEmpresa}
                    </div>
                  </div>
                </div>
              </a>)}
            </div>
          </div>
        </div>
      )
    }
    if (passagens) {
      return (
        <div className="alert alert-warning text-center mt-4" role="alert">
          Nenhum resultado encontrado para sua pesquisa.
        </div>
      )
    }
  }

  limpaViagens (sentido) {
    if (sentido === 'pesquisaOrigem') {
      this.props.selecionarOrigem(null);
    }
    if (sentido === 'pesquisaDestino') {
      this.props.selecionarDestino(null);
    }
    this.props.selecionarViagem({})
    this.props.limparViagens()
  }

  render () {
    return (
        <React.Fragment>
          <div className="card text-center border-0">
            <div className="card-group">
              <div className="col-12 col-sm-12 col-md-4">
                <SelecaoCidadeAutocomplete nome='pesquisaOrigem'
                                           name='pesquisaOrigem'
                                           limparViagens={this.limpaViagens.bind(this)}
                                           placeholder='Cidade origem'
                                           ehVenda={true}
                                           selecionarCidade={this.props.selecionarOrigem}
                                           value={this.props.origem}/>
              </div>
              <div className="col-12 col-sm-12 col-md-4">
                <SelecaoCidadeAutocomplete nome='pesquisaDestino'
                                           name='pesquisaDestino'
                                           ehVenda={true}
                                           limparViagens={this.limpaViagens.bind(this)}
                                           placeholder='Cidade destino'
                                           selecionarCidade={this.props.selecionarDestino}
                                           value={this.props.destino}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-2">
                {this.exibirCalendario(true)}
              </div>
              {this.exibirBotaoPesquisar()}
            </div>
            <div>
              {this.exibirItinerario(this.props.viagens.passagensIda)}
            </div>
          </div>
        </React.Fragment>
    )
  }
}


export const mapStateToProps = state => (
  {
    origem: state.origem,
    destino: state.destino,
    dataIda: state.dataIda,
    viagens: state.viagens,
    empresaSelecionada: state.empresaSelecionada,
    viagem: state.viagem
  });


export default connect(mapStateToProps,
  {
    selecionarDestino,
    selecionarOrigem,
    selecionarDataIda,
    buscarViagens,
    selecionarViagem,
    limparViagens,
    selecionarViagemIda
  })(AbaItinerario)
